<template>
  <div
    class="main"
    data-app="true"
  >
    <JumbotronView :message="header" />
    <v-app class="app-style mx-auto">
      <v-row
        no-gutters
      >
        <v-col
          cols="12"
          md="8"
          offset-md="2"
        >
          <code-entry-card/>
        </v-col>
      </v-row>
    </v-app>
  </div>
</template>

<script>
import CodeEntryCard from './CodeEntryCard.vue';
import JumbotronView from '../JumbotronView.vue';

export default {
  name:       'DMLandingPage',
  metaInfo: {
    title: 'Redeem Your Offer',
    meta: [
      {
        name: 'description',
        content: 'Receive a pre-qualification letter from NetCredit? Use your 8-character offer code to redeem your limited-time offer!'
      }
    ]
  },
  components: {
    CodeEntryCard,
    JumbotronView,
  },
  props: {},
  data() {
    return {
      header: 'Welcome to NetCredit',
    };
  },
};
</script>

<style scoped lang="scss">
  #app.app-style.v-application {
    font-family: 'Open Sans';
    background-color: #F2F2F2;
    ::v-deep .v-application--wrap {
      min-height: auto;
    }
    @media (max-width: 768px) {
      padding: 0;
    }

    @media (min-width: 768px) {
      padding: 30;
    }
  }
</style>
